import { useApi } from '@/api';
import { ActivityCard, Page } from '@/components';

import { useSparkColor } from '@/hooks';
import { ChartSkeleton, CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import Kpis from './Kpis';
import TopHolders from './TopHolders';

type DataResponse = {
  symbol: string;
  total_supply: string;
  networks: string[];
  rate: string;
  underlying_address: string;
  underlying_symbol: string;
  address: string;
};

export default function SparkTokenPage() {
  const color = useSparkColor();

  const [data, error] = useApi<DataResponse>({
    url: '/sparkstar/spk/token/',
    queryParams: {}
  });
  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Page
      title={
        <>
          <CryptoIcon name={data.symbol} address={data.address} size="3" />
          <Heading size="1">
            <Flex gap="xs">{data.symbol} Token</Flex>
          </Heading>
        </>
      }>
      <Kpis />
      <ActivityCard
        url="/sparkstar/spk/token/activity/"
        linkTo="./activity"
        onClickUrl="./activity"
        color={color}
      />
      <TopHolders symbol={data.symbol} address={data.address} />
    </Page>
  );
}
